<template>
    <div :id="targetId" :class="targetCssClasses">
        <!-- Plotly chart will be drawn inside this DIV -->
    </div>
</template>


<script>

 import Vue from 'vue';
 import Plotly from 'plotly.js-dist-min';
 import _ from 'lodash';

  /* Plotly.register([
   *     require('plotly.js/lib/bar'),
   *     require('plotly.js/lib/barpolar'),
   *     require('plotly.js/lib/choropleth'),
   *     require('plotly.js/lib/heatmap'),
   *     require('plotly.js/lib/pie'),
   *     require('plotly.js/lib/scatter'),
   * ]); */

 export default {
     props: {
         targetId: {
             type: String
         },
         targetCssClasses: {
             type: String,
             default: ''
         },
         bcData: {
             type: Array,
             require: true,
             default: function () {
                 return {};
             }
         },
         bcLayout: {
             type: Object,
             default: function () {
                 return {};
             }
         },
         bcOptions: {
             type: Object,
             default: function () {
                 return {};
             }
         }
     },
     data: function () {
         return {
             resizeObserver: null,
             container: null,
         };
     },
     computed: {
         series: function () {
             return this.bcData;
         },
         layout: function () {
             return this.bcLayout;
         }
     },

     watch: {
         bcData: {
             handler: function (newData, oldData) {
                 this.update();
             },
             deep: true
         },
         targetId: {
             handler: function (oldId, newId) {
                 console.log(oldId, newId);
             }
         }
     },
     mounted () {
         this.render()
     },
     beforeUnmount() {
         const targetDiv = document.getElementById(this.targetId);
         if (targetDiv) {
             Plotly.purge(this.targetId);
         }
         this.resizeObserver.unobserve(this.container);
     },
     methods: {
         update () {
             const targetDiv = document.getElementById(this.targetId);
             if (targetDiv) {
                 Plotly.purge(this.targetId);
             }
             Plotly.react(
                 this.targetId,
                 this.bcData,
                 this.bcLayout,
                 this.bcOptions
             );
         },
         render () {
             if (this.targetId) {
                 let d3 = Plotly.d3;

                 Plotly.react(
                     this.targetId,
                     this.bcData,
                     this.bcLayout,
                     this.bcOptions
                 ).then(() => {
                     if (!this.container) {
                         // Resize
                         this.container = document.getElementById(this.targetId).parentNode.parentNode;
                         this.resizeObserver = new ResizeObserver(() => {
                             this.resize();
                         });
                         this.resizeObserver.observe(this.container);
                     }
                     this.resize();
                 });
             }
         },
         resize: function() {
             try {
                 Plotly.Plots.resize(this.targetId);
             } catch(err) {
                 this.resizeObserver.unobserve(this.container);
             }
         }
     }
};
</script>



// WEBPACK FOOTER //
// BasicChart.vue?9e3590b0